import { css } from '@linaria/core';
import { breakpoints, colors } from '@spaceshipapp/cambridge';

const { brandSecondary } = colors;

export const globals = css`
  :global() {
    body {
      background-color: ${brandSecondary};
    }

    .container {
      width: 100%;
      margin-right: auto;
      margin-left: auto;
      padding-right: 1rem;
      padding-left: 1rem;

      @media (min-width: ${breakpoints.sm}) {
        max-width: ${breakpoints.sm};
      }

      @media (min-width: ${breakpoints.md}) {
        max-width: ${breakpoints.md};
      }

      @media (min-width: ${breakpoints.lg}) {
        max-width: ${breakpoints.lg};
      }

      @media (min-width: ${breakpoints.xl}) {
        max-width: ${breakpoints.xl};
      }
    }
  }
`;
